import * as go from 'gojs';

import {
  BaseLayoutSettings,
  ForceLayoutSettings,
  LayeredDigraphLayoutSettings,
  LayoutAlgorithmType,
} from 'src/containers/ProjectDiagram/templates/extensions/layouts/types';

export const defaultLayoutSettings: BaseLayoutSettings = {
  useUndoManager: true,
  linkKeyProperty: 'key',
};

export const defaultD3ForceDirectedLayoutSettings: ForceLayoutSettings = {
  ...defaultLayoutSettings,
  enableChargeForce: true,
  enableCollisionForce: true,
  enableLinkForce: true,
  edgeMinLength: 200,
  nodeInitialDistance: 500,
  layoutCollideOffset: 2,
  layoutCollideSimulationIterations: 3,
  layoutSimulationAlpha: 1,
  layoutForceMinCharge: 10,
  layoutForceMaxCharge: 10000,
  layoutManyBodyStrengthMultiplier: 50,
  edgeOffset: 500,
  edgePropertyEdgeOffset: -100,
  separateGraphOffset: 3000,
  labelTextPadding: 10,
};

export const defaultGoJsLayeredDigraphLayoutSettings: LayeredDigraphLayoutSettings =
  {
    ...defaultLayoutSettings,
    direction: 0,
    layerSpacing: 400,
    columnSpacing: 100,
    isRouting: false,
    setsPortSpots: false,
    nonParallelLinksAreOrthogonal: true,
    maxParallelPortRadians: Math.PI / 4,
    parallelPortRibbonSpacing: 1.25,
    forwardLinkSettings: {
      routing: go.Routing.Normal,
      curviness: 10,
      fromEndSegmentLength: 400,
      toEndSegmentLength: 200,
    },
    backwardLinkSettings: {
      routing: go.Routing.AvoidsNodes,
      curviness: 50,
      fromEndSegmentLength: 200,
      toEndSegmentLength: 400,
    },
    forceLayoutSettings: defaultD3ForceDirectedLayoutSettings,
  };

export const getDefaultSettingsForLayoutType = (type: LayoutAlgorithmType) => {
  switch (type) {
    case LayoutAlgorithmType.D3_FORCE_LAYOUT:
      return defaultD3ForceDirectedLayoutSettings;
    case LayoutAlgorithmType.GO_JS_HORIZONTAL_LAYERED_DIGRAPH_LAYOUT:
    case LayoutAlgorithmType.GO_JS_VERTICAL_LAYERED_DIGRAPH_LAYOUT:
      return defaultGoJsLayeredDigraphLayoutSettings;
    default:
      throw new Error(`Unknown layout algorithm type: ${type}`);
  }
};
